import { createQueryKeys } from '../../factories';

export const AUTOMATION_JOB_NAMESPACE = ['automation', 'jobs'];
export const automationJobQueryKeyFactory = createQueryKeys(
	AUTOMATION_JOB_NAMESPACE
);
